var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 62,
    viewBox: "0 0 69 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 53.3999C66.5 55.0973 65.8257 56.7252 64.6255 57.9254C63.4253 59.1257 61.7974 59.7999 60.1 59.7999H8.9C7.20261 59.7999 5.57475 59.1257 4.37452 57.9254C3.17428 56.7252 2.5 55.0973 2.5 53.3999V8.59995C2.5 6.90257 3.17428 5.2747 4.37452 4.07447C5.57475 2.87423 7.20261 2.19995 8.9 2.19995H24.9L31.3 11.8H60.1C61.7974 11.8 63.4253 12.4742 64.6255 13.6745C65.8257 14.8747 66.5 16.5026 66.5 18.2V53.3999Z",
    stroke: "#212945",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9921 45.2768C40.43 45.2768 44.8383 40.8685 44.8383 35.4306C44.8383 29.9927 40.43 25.5845 34.9921 25.5845C29.5543 25.5845 25.146 29.9927 25.146 35.4306C25.146 40.8685 29.5543 45.2768 34.9921 45.2768Z",
    stroke: "#212945",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9922 31.4922V39.3691",
    stroke: "#212945",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0537 35.4307H38.9306",
    stroke: "#212945",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6308,
    height: 23.6308,
    fill: "white",
    transform: "translate(23.1768 23.6152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPlus);
export default __webpack_public_path__ + "static/media/folderPlus.989086247867be7800195bf7f674d45b.svg";
export { ForwardRef as ReactComponent };